import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';

import { DriverCentralDetailsModalComponent } from './driver-central-details-modal.component';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    DriverCentralDetailsModalComponent,
  ],
  exports: [DriverCentralDetailsModalComponent],
})
export class DriverCentralDetailsModalModule {}
